<template>
    <div class="h-full timetable-comp">
        <TimeTracker
            :board_id="board_id"
            :currentUser="currentUser"
            @showUploadState="showUploadState"
            :dragScroll="dragScroll"
        />
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import {Container, Draggable} from "vue-smooth-dnd";
import {applyDrag, difference} from "@/mixins/helpers";
import Flash from "@/components/Flash.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import TimeTracker from "@/components/organism/TimeTracker.vue";
import { mapActions } from 'vuex';
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import VModal from "@/components/atoms/VModal.vue";
import ConflictSavingModal from "@/components/molecules/ConflictSavingModal.vue";

export default {
    name: "TimeTable",
    components: {
        Container,
        Draggable,
        Flash,
        ConfirmDelete,
        Textfield,
        TextArea,
        Dropmenu,
        TimeTracker,
        VModal,
        ConflictSavingModal
    },
    props: ["board_id", "currentUser", "dragScroll"],
    data: function () {
        return {
            
        };
    },
    methods: {
        showUploadState(files, taskID) {
            this.$emit('showUploadState', files, taskID)
        }
    }
};
</script>

<style lang="scss">

</style>
